import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-voicePause5",
  "use": "icon-voicePause5-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-voicePause5\">\r\n<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#838399\" />\r\n<path d=\"M13.3215 9.44002L9.12167 6.64013C8.63168 6.29014 8.00171 6.64013 8.00171 7.20011V12.7999C8.00171 13.3599 8.63168 13.7099 9.12167 13.3599L13.3215 10.56C13.6715 10.28 13.6715 9.72001 13.3215 9.44002Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol